module.exports = __webpack_public_path__ + "img/00045.4510a1b1.webp";